<template>
  <v-container :v-if="valid" fluid class="full-height ma-0 pa-1" style="border:0px solid green;">
    <v-row class="ma-2 pa-0" style="border:0px solid red;">
      <v-col class="ma-0 pa-0" cols="12">

         <!-- Property Performance Detail Desktop -->
        <v-card class="hidden-md-and-down">
          <v-card-title>Property Performance Detail: {{site_metadata.get('dis')}}</v-card-title>
          <v-card-subtitle></v-card-subtitle>
          <v-card-text>
            <v-container fluid>
              <v-row row>
                <!-- Left -->
                <v-col cols="4">
                  <v-container fluid>
                    <v-row row>
                      <v-col cols="6">Property Performance Detail:</v-col>
                      <v-col cols="6">{{site_metadata.get('dis')}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Attachment:</v-col>
                      <v-col cols="6">{{site_metadata.get('carnego_attachment')}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Area:</v-col>
                      <v-col cols="6">{{site_metadata.get('area')}} m2</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Orientation:</v-col>
                      <v-col cols="6">{{site_metadata.get('carnego_orientation')}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">PV system size:</v-col>
                      <v-col cols="6">{{site_metadata.get('carnego_pvSize')}} kWp</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Battery size:</v-col>
                      <v-col cols="6">{{site_metadata.get('carnego_batterySize')}}</v-col>
                    </v-row>
                  </v-container>
                </v-col>

                <!-- Right -->
                <v-col cols="4">
                  <v-container fluid>
                    <v-row row>
                      <v-col cols="6">Property Type:</v-col>
                      <v-col cols="6">{{site_metadata.get('carnego_batterySize')}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Customer:</v-col>
                      <v-col cols="6">{{capitalizeFirstLetter(organisation_metadata.get('dis'))}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Project:</v-col>
                      <v-col cols="6">{{capitalizeFirstLetter(sitegroup_metadata.get('carnego_project_name'))}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Phase:</v-col>
                      <v-col cols="6">{{capitalizeFirstLetter(sitegroup_metadata.get('carnego_project_phase'))}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Monitoring Start Date:</v-col>
                      <!-- <v-col cols="6">{{siteGroupInfo.settings.start_date}}</v-col> -->
                      <v-col cols="6">14-Nov-2021</v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>

            <PortfolioManagerTable :siteRef="siteRef"></PortfolioManagerTable>

          </v-card-text>
        </v-card>

        <!-- Property Performance Detail Mobile -->
        <v-card class="hidden-lg-and-up">
          <v-card-title>Property Performance Detail: {{site_metadata.get('dis')}}</v-card-title>
          <v-card-subtitle></v-card-subtitle>
          <v-card-text>
            <v-container fluid>
              <v-row row>
                <!-- Left -->
                <v-col cols="12">
                  <v-container fluid>
                    <v-row row>
                      <v-col cols="6">Property Performance Detail:</v-col>
                      <v-col cols="6">{{site_metadata.get('dis')}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Attachment:</v-col>
                      <v-col cols="6">{{site_metadata.get('carnego_attachment')}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Area:</v-col>
                      <v-col cols="6">{{site_metadata.get('area')}} m2</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Orientation:</v-col>
                      <v-col cols="6">{{site_metadata.get('carnego_orientation')}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">PV system size:</v-col>
                      <v-col cols="6">{{site_metadata.get('canego_pvSize')}} kWp</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Battery size:</v-col>
                      <v-col cols="6">{{site_metadata.get('carnego_batterySize')}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Property Type:</v-col>
                      <v-col cols="6">{{site_metadata.get('carnego_batterySize')}}</v-col>
                    </v-row>

                     <v-row row>
                      <v-col cols="6">Customer:</v-col>
                      <!-- <v-col cols="6">{{site_metadata.get('carnego_customer')}}</v-col> -->
                      <v-col cols="6">{{capitalizeFirstLetter(organisation_metadata.get('dis'))}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Project:</v-col>
                      <!-- <v-col cols="6">{{siteGroupInfo.settings.name}}</v-col> -->
                      <v-col cols="6">{{capitalizeFirstLetter(sitegroup_metadata.get('carnego_project_name'))}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Phase:</v-col>
                      <!-- <v-col cols="6">{{siteGroupInfo.settings.phase}}</v-col> -->
                      <v-col cols="6">{{capitalizeFirstLetter(sitegroup_metadata.get('carnego_project_phase'))}}</v-col>
                    </v-row>

                    <v-row row>
                      <v-col cols="6">Monitoring Start Date:</v-col>
                      <!-- <v-col cols="6">{{siteGroupInfo.settings.start_date}}</v-col> -->
                      <v-col cols="6">14-Nov-2021</v-col>
                    </v-row>

                  </v-container>
                </v-col>
               
              </v-row>
            </v-container>

            <PortfolioManagerTable :siteRef="siteRef"></PortfolioManagerTable>

          </v-card-text>
        </v-card>

      </v-col>
    </v-row>

  </v-container>
</template>

<script lang="ts">
import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import FaceRating from '@/components/FaceRating.vue';
import PortfolioManagerTable from './PortfolioManagerTable.vue';
import { Route, RawLocation } from  'vue-router';

interface IKeyValue {
  name: string;
  value: string;
}

@Component({
  components: {
    FaceRating,
    PortfolioManagerTable,
  },
  // beforeRouteEnter(to, from, next){
  //       next(vm => {
  //           alert('Entering Foo');
  //       });
  // },
})
export default class PortfolioManagerSiteDetails extends Vue {

  // @Prop({ default: () => '' }) public siteRef!: string;
  private siteRef: string = '';
  private valid: boolean = false;
  private showWait: boolean = true;
  private site_metadata: Map<String, string> = new Map();
  private sitegroup_metadata: Map<String, string> = new Map();
  private organisation_metadata: Map<String, string> = new Map();

  public async created() {
    const self = this;
  }

  // public beforeRouteEnter (to: Route, from: Route, next: any): void {
  //       alert('beforeRouteEnter')       // not triggered!
  //       next((vm: Vue.Component) => {
  //           debugger;   // not triggered!
  //           next();
  //       });
  //   }

  public async display() {

    const self = this;

    self.siteRef = self.$route.params.id;

    const results = await Promise.all([self.get_info("site_infos.json", self.siteRef), 
                                       self.get_info("sitegroup_info.json"),
                                       self.get_info("organisation_info.json")
                                       ]);

    if(results) {
      self.site_metadata = results[0];
      self.sitegroup_metadata = results[1];
      self.organisation_metadata = results[2];

      // alert([...self.organisation_metadata.entries()]);

      self.valid = true;
    }

    self.showWait = false;
  }

  public async mounted() {
    const self = this;

    self.showWait = true;

    await self.$nextTick();
    self.display();

    return;
  }

  private capitalizeFirstLetter(s: string): string {
    if(s === undefined) {
      return "Unknown"
    }

    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  private async get_info(url: string, reference?: string): Promise<Map<string, string>> {

    const data = await this.$store.dispatch('requestStaticFileForSiteGroupId', {"product": "tagged_portfolio_generator", "filename": url}, {timeout: 30000}); 

    const lines = data.split('\n');

    const last_run_header = lines[0];

    // const last_time_str = JSON.parse(last_run_header)['last_run'];

    for (const line of lines.slice(1)) {

      if(line === '') {
        break;
      }

      const lineJson = JSON.parse(line);
      const tagsJson = JSON.parse(lineJson["tags"]);

      if (reference !== undefined) {
        if (tagsJson["carnego_ref"] !== reference) {
          continue;
        }
      }
    
      const tagArray: [string, string][] = Object.entries(tagsJson);

      return new Map(tagArray);
    }

    return new Map();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>